<template>
  <SectionPage :img="img" :content="content" :btn="btn" :icon="icon"/>
</template>

<script>
import SectionPage from '@/layout/SectionPage.vue'
export default {
  name: "Section3",
  components: {
    SectionPage
  },
  data() {
    return {
      img: require('@/assets/section-bg/section3.jpg'),
      content: {
        componentsType: {
          pc: 'shortBtn sectionBtn',
          mobile: 'shortBtn sectionBtn'
        },
        title: '03\nLIFESTYLE',
        text: 'Let us know your daily diet and fitness routine, so as to better provide you with customized nutrition guidance.'
      },
      btn:{
        text: 'Next',
        link: '/questionnaire/section3/1',
      },
      icon: require('@/assets/icon/section-03.png')
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
